import { render } from "./Acceleration.vue?vue&type=template&id=2c1ea890"
import script from "./Acceleration.vue?vue&type=script&lang=js"
export * from "./Acceleration.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__